var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 6,
    viewBox: "0 0 4 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.997309 0.874952C0.964601 0.908438 0.946289 0.953392 0.946289 1.0002C0.946289 1.04701 0.964601 1.09196 0.997309 1.12545L2.82468 3.00008L0.997309 4.87433C0.964601 4.90781 0.946289 4.95277 0.946289 4.99958C0.946289 5.04639 0.964601 5.09134 0.997309 5.12483C1.01321 5.14115 1.03222 5.15413 1.05321 5.16299C1.07421 5.17186 1.09677 5.17642 1.11956 5.17642C1.14235 5.17642 1.16491 5.17186 1.18591 5.16299C1.2069 5.15413 1.22591 5.14115 1.24181 5.12483L3.18506 3.13095C3.21919 3.09594 3.23829 3.04897 3.23829 3.00008C3.23829 2.95118 3.21919 2.90422 3.18506 2.8692L1.24181 0.875327C1.22591 0.858998 1.2069 0.84602 1.18591 0.837158C1.16491 0.828296 1.14235 0.82373 1.11956 0.82373C1.09677 0.82373 1.07421 0.828296 1.05321 0.837158C1.03222 0.84602 1.01321 0.858998 0.997309 0.875327V0.874952Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.b185fabbb69845e818e318a14e2848e7.svg";
export { ForwardRef as ReactComponent };